<div class="section-ctnr">
    <div class="section-head">
        <h1>Memorandum Of Understanding Details</h1>
    </div>
    <hr />
    <div class="row" [innerHtml]="mouAcknowledgedOn"></div>
    <div class="row" [innerHtml]="mouLanguage"></div>
</div>
